/**
 * Centralized locale configuration
 * Add or remove locales here to manage all supported languages
 */

const LOCALES = {
  // Default locale (served at root path /)
  DEFAULT: 'en',

  // All supported locales
  SUPPORTED: ['en']
};

/**
 * Get all non-default locales (for getStaticPaths)
 * @returns {Array} Array of locale objects for getStaticPaths
 */
function getNonDefaultLocales() {
  return LOCALES.SUPPORTED.filter(locale => locale !== LOCALES.DEFAULT).map(locale => ({
    params: {locale}
  }));
}

/**
 * Check if a locale is supported
 * @param {string} locale - The locale to check
 * @returns {boolean} True if locale is supported
 */
function isLocaleSupported(locale) {
  return LOCALES.SUPPORTED.includes(locale);
}

module.exports = {
  LOCALES,
  getNonDefaultLocales,
  isLocaleSupported
};
